import React, {useState,useEffect} from 'react';
import { NavLink,useNavigate, useLocation } from "react-router-dom";
import { NavDropdown,Placeholder } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { dynamicUrl,LangValue } from './Function';
import MegaMenu from './MegaMenu';
const MainMenuItems = ({ menu }) => 
{
    const { t } = useTranslation();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const navigate = useNavigate();
    const location = useLocation();
    const [showDropdown, toggleDropdown] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => 
    {
        const handleResize = () => 
        {
            setIsMobile(window.innerWidth < 992);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => { window.removeEventListener('resize', handleResize); };
    }, [menu]);
    return (
        <React.Fragment>
        {menu.submenu ? ( 
            <React.Fragment>           
            {menu.sp_mega_menu === 1 ? (                
            <NavDropdown key={menu.sp_id} 
                className={`mega-menu ${location.pathname.includes(LangValue(menu, 'sp_htaccess')) ? 'active' : ''}`}
                title={LangValue(menu,'sp_name')} 
                show={isMobile ? true : showDropdown}
                onMouseEnter={() => { if (!isMobile) toggleDropdown(true); }}
                onMouseLeave={() => { if (!isMobile) toggleDropdown(false); }}
                onClick={() => { navigate(dynamicUrl(menu))}} >
                    <MegaMenu menu={menu} toggleDropdown={toggleDropdown} />                
                </NavDropdown>                
            ) : (
            <NavDropdown key={menu.sp_id}
             className={`${location.pathname.includes(LangValue(menu, 'sp_htaccess')) ? 'active' : ''}`}
             title={LangValue(menu,'sp_name')} 
             show={isMobile ? true : showDropdown}
             onMouseEnter={() => { if (!isMobile) toggleDropdown(true); }}
             onMouseLeave={() => { if (!isMobile) toggleDropdown(false); }}
             onClick={() => { navigate(dynamicUrl(menu))}} >
                {menu.submenu.map((submenu, index) => (
                    <React.Fragment key={index}>
                        {submenu.sp_id === 45 &&
                        <DynamicLink spId={7} toggleDropdown={toggleDropdown} /> }
                        <NavLink                      
                        className={({ isActive }) => (isActive ? 'active dropdown-item' : 'dropdown-item')}
                        to={`/${LangValue(menu,'sp_htaccess')}/${LangValue(submenu,'sp_htaccess')}${submenu.sp_redirect === 1 && submenu.submenu && submenu.submenu[0] ? '/' + LangValue(submenu.submenu[0], 'sp_htaccess') : ''}`}
                        aria-label={LangValue(submenu,'sp_name')}
                        onClick={(e) => {
                            e.stopPropagation();
                            toggleDropdown(false);
                        }}
                        >
                        {LangValue(submenu,'sp_name')}
                        </NavLink>
                        {submenu.sp_id === 47 &&
                        <DynamicLink spId={344} toggleDropdown={toggleDropdown} /> }
                    </React.Fragment>
                ))}
                {menu.sp_id === 8 &&
                <a className='dropdown-item' href="https://igdtuw.in/IGDTUW/logincheck" aria-label={appLanguage === "hi" ? 'परीक्षा के लिए ERP पोर्टल' : 'ERP Portal for Exam'} target="_blank" rel="noopener noreferrer">
                    {appLanguage === "hi" ? 'परीक्षा के लिए ERP पोर्टल' : 'ERP Portal for Exam'}
                    <span className="visually-hidden"> {t('externalLinkIndicator')}</span>
                    <i className="bi bi-link-45deg" aria-hidden="true"></i>
                </a>
                }
            </NavDropdown>
            )}            
            </React.Fragment>      
        ) : (
        <NavLink key={menu.sp_id} to={LangValue(menu,'sp_htaccess')} className={({ isActive }) => (isActive ? 'active nav-link' : 'nav-link')}>
            {LangValue(menu,'sp_name')}
        </NavLink>
        )}
        </React.Fragment>
    );
  };
  
  export default MainMenuItems;

  const DynamicLink = ({spId, toggleDropdown}) => 
{
    const[isLoading, setLoading] = useState(true);
    const[Links,setLinks]=useState([]);
    useEffect(()=>
    {
        const getDynamicLink = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/MenuById/"+spId);
                const result = await response.json();
                setLinks(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('DynamicLink : Result',result); }
            
            } catch (error) 
            {
                console.error('DynamicLink : Error', error.message);
            }
        };
        getDynamicLink();    
    },[spId])
    return (
        <React.Fragment>
            {isLoading ? (
                <NavLink><Placeholder xs={12} /></NavLink>
            ) : (
            <React.Fragment>
            {Links.map((sp,index)=>(
                <NavLink key={index} className={({ isActive }) => (isActive ? 'active dropdown-item' : 'dropdown-item')}
                to={dynamicUrl(sp)} aria-label={LangValue(sp,'sp_name')}
                onClick={(e) => {
                    e.stopPropagation();
                    toggleDropdown(false);
                    }}
                >{LangValue(sp,'sp_name')}</NavLink>
            ))}
            </React.Fragment>
            )}
        </React.Fragment>
    );
}